import setItemMenu from "./setItemMenu";

export default function setRules(res) {
	localStorage.setItem("token", res.headers["x-token"]);
	setItemMenu(res.headers["x-user-type"]);
}
